import { render, staticRenderFns } from "./o-google-doc-link.vue?vue&type=template&id=e4ba5a3e&scoped=true&"
import script from "./o-google-doc-link.vue?vue&type=script&lang=js&"
export * from "./o-google-doc-link.vue?vue&type=script&lang=js&"
import style0 from "./o-google-doc-link.vue?vue&type=style&index=0&id=e4ba5a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ba5a3e",
  null
  
)

export default component.exports